export default __webpack_public_path__ + "assets/audios/d3599d5d8094ab5af7fd3d48be6b35aa.mp3";